export default {
    title: state => {
        return state.title;
    },
    serviceGroups: state => {
        return state.serviceGroups;
    },
    activeServiceGroups: state => {
        return state.activeServiceGroups;
    },
    serviceGroup: state => {
        return state.serviceGroup;
    },
    serviceGroupsToEdit: state => {
        return state.serviceGroupsToEdit;
    },
    total: state => {
        return state.total;
    }
}
